import React, { PropsWithChildren } from 'react';

export const Spinner: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="spinner overlay w-100 h-100 position-absolute d-flex flex-column gap-2 justify-content-center align-items-center">
      <span className={'loader'} role="status"></span>
      {children}
    </div>
  );
};
